<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="J" :itemcode="pagecode"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div v-if="userdata.token">
					
				<div class="whitebox right_topbox" style="padding-bottom: 0;">
					<div class="right_boxtitle">
						<span class="fl right_title">本{{sreachType == 1?'省':'市'}}新增投资分析</span>
						<span class="fr showechart-c6" @click="showechart=!showechart" v-show="isShowChart">{{showechart?'隐藏':'查看'}}图表</span>
					</div>
					<div>
						<div class="opport-screen-list1">
							<div class="spage-searchbox ">
								<dl class="opport-screen bdbe">
									<dt class="fl">投资来源</dt>
									<dd class="fl">
										<span :key="index" v-for="(item,index) in provinceOptions"
											:class="provinceValue == item.value ?'a-screen current':'a-screen'"
											@click="provinceSouceToggle(item)">{{item.label}}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="provinceValue != 2 && provinceOptionData.length>0">
									<dt class="fl">来源省份</dt>
									<dd class="fl">
										<span :class="provinceId === ''?'a-screen current':'a-screen'"
											@click="provinceId = '';cityId='';cityOptionData=[];getCompanyList(1)">全部</span>
										<span :key="index" v-for="(item,index) in provinceOptionData"
											:class="provinceId === item.areaId ?'a-screen current':'a-screen'"
											@click="provinceToggle(item)">{{item.areaName}}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="cityOptionData.length>0">
									<dt class="fl">来源城市</dt>
									<dd class="fl">
										<span :class="cityId === '' ?'a-screen current':'a-screen'"
											@click="cityId = '';getCompanyList(1)">全部</span>
										<span :key="index" v-for="(item,index) in cityOptionData"
											:class="cityId === item.areaId ?'a-screen current':'a-screen'"
											@click="cityToggle(item)">{{item.areaName}}</span>
									</dd>
								</dl>
								<finacingTime v-on:chooseFinancing="chooseFinancing" dlname="成立" type="month" :key="'time'+monthKey" 	:showTips='false' :timetype='3'></finacingTime>
								<dl class="opport-screen bdbe">
									<dt class="fl">产业分类</dt>
									<dd class="fl">
										<span :class="chooseNotion == 0 ?'a-screen current':'a-screen'"
											@click="notionlist2=[];chooseNotion2='';chooseNotion = 0;getCompanyList(1);">全部</span>
										<span :key="index" v-for="(item,index) in notionlist"
											:class="chooseNotion == item.value ?'a-screen current':'a-screen'"
											@click="chooseNotionFn(item,1)">{{item.name}}</span>
									</dd>
								</dl>
								<dl class="opport-screen bdbe" v-show="notionlist2.length>0">
									<dt class="fl titleop">细分产业</dt>
									<dd class="fl">
										<span :class="chooseNotion2 == '' ?'a-screen current':'a-screen'"
											@click="chooseNotion2 = '';getCompanyList(1);">全部</span>
										<span :key="index" v-for="(item,index) in notionlist2"
											:class="chooseNotion2 == item.value ?'a-screen current':'a-screen'"
											@click="chooseNotionFn(item,2)">{{item.name}}</span>
									</dd>
								</dl>
							</div>
						</div>
						

					</div>
				</div>
				<div class="whitebox">
					<!-- 柱状图 概念企业数量 -->
					<div class="fixedEchartBar1 w95mg oh por pt-2" v-show="showechart && isShowChart">
						<div class="fl" style="width: 48%;margin-right: 40px;" v-show="provinceId === '' || cityId === '' || chooseNotion == 0 || chooseNotion2 == '' ">
							<div class="land-ecahrt-title">
								<h5 :class="cityInvestType == 1 ? 'current title fl':'title fl'"
									@click="PiechartFun('fixedEchartPie',1)" v-show="provinceId === '' && provinceValue != 2">投资来源省份分布 </h5>
								<h5 :class="cityInvestType == 2 ? 'current title fl':'title fl'"
									@click="PiechartFun('fixedEchartPie',2)" v-show="cityId === ''">投资来源城市分布 </h5>
								<h5 :class="cityInvestType == 3 ? 'current title fl':'title fl'"
									@click="PiechartFun('fixedEchartPie',3)" v-show="chooseNotion == 0">投资项目行业分布</h5>
								<h5 :class="cityInvestType == 4? 'current title fl':'title fl'"
									@click="PiechartFun('fixedEchartPie',4)" v-show="chooseNotion2 == '' && chooseNotion != 0">投资项目行业分布</h5>
							</div>
							<!-- <div class="land-ecahrt-title tac" v-show="provinceValue == 2 && cityId ===''"><b>投资来源城市分布</b></div> -->
							<div id="fixedEchartPie" class="echart-line-box" :style="'width:'+echartWidth2+'px;'"></div>
						</div>
						<div class="fl" style="width: 48%;">
							<div class="land-ecahrt-title tac"><b>新增投资数量趋势</b></div>
							<div id="fixedEchartBar" class="echart-line-box" :style="'width:'+echartWidth2+'px;'"></div>
						</div>
						<span class="closebtn" @click="showechart=false"></span>
					</div>
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
					</div>
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="enterpristlist.length!=0">
							<tr>
								<th>序号</th>
								<th>企业名称 </th>
								<th>
									<div :class="{'td_sortname ':true,'current':orderField == 1}" @click="tablesort(1)">
										<span :class="{'sortname ':true,'current':orderField ==  1}">注册资本<i 	:class="orderType == 1? 'timesorticon up':'timesorticon down'"></i></span>
									</div> 
								</th>
								<th>所属行业</th>
								<th>投资地点</th>
								<th>
									<div :class="{'td_sortname ':true,'current':orderField == 0}" @click="tablesort(0)">
										<span :class="{'sortname ':true,'current':orderField == 0}">投资时间<i :class="orderType == 1?'timesorticon up':'timesorticon down'"></i></span>
									</div> 
								</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist" v-if="i<freeUserNum">
								<td>{{20*(page-1)+i+1}}</td>
								<td class="title" @click="routerlinkarry('/investEnterpirseDetail',{'id':list.stockCode,'type':1})">{{list.title}}
								</td>
								<td>{{list.regCapital}}</td>
								<td>{{list.industry}}</td>
								<td>{{list.area}}</td>
								<td>{{list.createTime}}</td>
							</tr>
						</table>
						<div class="w95mg"><freeUserTips :type="2" :bgtype="26" v-if="enterpristlist.length>3  && userdata.isFree" ></freeUserTips></div>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="getCompanyList">
						</zpagenav>
					</div>
				</div>
			
				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0"></freeUserTips>
					</div> 
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { dataInJs } from "../../utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";
	import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"

	export default {
		name: 'index',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite: this.$api.getWebsiteType(),
				echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48,
				title: "本地投资趋势",
				userdata: {},
				areaData:dataInJs(),
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数
				enterpristlist: [],
				provinceOptions: [{
					label: "全部",
					value: 0,
				}, {
					label: "外省",
					value: 1,
				}, {
					label: "本省",
					value: 2,
				}],
				pageOptions: [{
					label: "本省新增投资分析",
					value: 1,
					pagecode: 'J-BSXZTZFX'
				}, {
					label: "本市新增投资分析",
					value: 2,
					pagecode: 'J-BS-XZTZFX'
				}, ],
				pagecode: 'J-BSXZTZFX',
				showechart: true,
				isShowChart:true,//是否显示图表（免费用户不显示）
				provinceValue: 0,
				sreachType: 0,
				kwtextsearchtext: '',
				kwtextsearch: '',
				notionlist: [],
				chooseNotion: 0,
				month: '',monthKey:1,
				orderField: 0,
				orderType: 0,
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				provinceChartData: [],
				cityChartData: [],
				cityInvestType: 1,
				notionlist2:[],
				chooseNotion2:0,
				cityId:'',
				provinceId:'',
				provinceOptionData:dataInJs(),
				cityOptionData:[],
				ajaxNum:0,//接口请求次数用来存城市数据，第一次请求是赋值省份数据
				industry2ChartData:[],
				freeUserNum:3,
			}
		},
		components: {
		 freeUserTips
		}, 
		//监听路由变化、newVal：目标路由，oldVal:原路由，路由不同时重新请求数据
		watch: {
			$route: function(newVal, oldVal) { 
				console.log('watch router investanalysis');   
					this.resetPage(); 
			}
		},
		beforeCreate() {},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var that = this;
			this.userdata = this.getuseriformation(); 
			if(this.userdata.token){
				this.freeUserNum=this.userdata.isFree ? 3 : this.pageSize;
				this.isShowChart = this.userdata.groupType == 2 ? false : true;
				this.getNotionList();
			}
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5"; 
			if(this.userdata.token){
				this.resetPage();
			}
		},
		methods: {
			filterProvinceData(item){
				let filterData;
				if(item.areaId != 0){
					filterData=this.areaData.filter(list=>{
						return list.areaId == item.areaId; 
					})
					// console.log('过滤后的数据',filterData);
					this.cityOptionData = filterData[0].children;
				}else{
					this.cityOptionData = [];
				}
			},
			//省份地区切换
			provinceToggle(item){
				console.log('省份地区切换',item,this.areaData);
				this.provinceId = item.areaId;
				this.filterProvinceData(item);
				this.cityId = '';
				// this.cityInvestType= this.provinceValue == 2 ? 2 : 3;
				this.getCompanyList();
			},
			//城市地区切换
			cityToggle(item){
				console.log('城市地区切换',item);
				this.cityId = item.areaId;
				// this.cityInvestType= this.provinceValue == 2 ? 1: 3;
				this.getCompanyList();
			},
			//投资来源切换
			provinceSouceToggle(item){
				console.log('投资来源切换',item);
				this.provinceValue=item.value;
				this.month="";
				this.monthKey++;
				if(this.provinceValue == 2){
					this.provinceId = this.userdata.province;
					this.cityId = '';
					this.filterProvinceData({areaId:this.userdata.province});
				}
				this.getCompanyList();
			},
			//切换本省本市时清空所有已选数据 所有同个页面多个连接的都需要 
			resetPage(){
				this.sreachType = this.$route.query.type ? this.$route.query.type : 1;
				this.pagecode = this.sreachType == 1 ? 'J-BSXZTZFX' : 'J-BS-XZTZFX'; 
				this.provinceValue=0;
				this.month='';
				this.monthKey++;
				this.chooseNotion=0; 
				this.cityInvestType=1;
				this.provinceId = '';
				this.cityId = '';
				if(this.userdata.token){
					this.getCompanyList();

				}
			},
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getCompanyList();
			},
			//获取行业分类
			getNotionList() {
				return new Promise((resolve, reject) => {
					this.bus.$emit('loading', true);
					var that = this;
					this.$axios.get(this.$api.cyl.parameter.get()+"?parentValue="+this.chooseNotion, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) { 
						if (res.data.success) { 
							console.log('获取行业分类',res)
							if(that.chooseNotion!=0){
								that.notionlist2 = res.data.list;
							}else{
								that.notionlist = res.data.list;
							}
							// that.bus.$emit('loading', false);
						} else {

						}
					}).catch(function(error) {
						// 请求失败处理 console.log(error);
					});
				})
			}, 
			//成立时间筛选
			chooseFinancing(date1) { 
				this.month = date1 == 'year' ? '':date1;
				// this.provinceId = '';
				// this.cityId = '';
				this.getCompanyList();
			},
			//行业筛选
			chooseNotionFn(item, type) {
				console.log('xuanze', item, type);
				if(type == 1){
					this.chooseNotion = item.value;
					this.chooseNotion2 ='';
					// this.cityId = '';
					// this.provinceId = '';
					this.getNotionList();
				}else if(type == 2){
					this.chooseNotion2 = item.value;
				}
				// this.cityInvestType= this.provinceValue == 2 ? 2 : 1;
				this.month='';
				this.monthKey++;
				this.getCompanyList();
			},
			pageHandler(page) { 
				this.getCompanyList(page);
			},
			getCompanyList(pages) {
				this.bus.$emit('loading', true);
				this.page = pages ? pages : 1;
				var that = this; 
				// let industry = this.chooseNotion2 == ''?this.chooseNotion:this.chooseNotion2;
				var querydata={page:this.page,source:this.provinceValue,month:this.month,industry:this.chooseNotion,industry2:this.chooseNotion2,province:this.provinceId,city:this.cityId,}; 
				let ajaxUrl = this.sreachType == 1 ? this.$api.park.localInvest.province(querydata) : this.$api.park.localInvest.city(querydata); 
				ajaxUrl=ajaxUrl+'&orderField='+this.orderField+'&orderType='+this.orderType; 
				// 4aef66eae5b3026530eb2625048bf8bc //本地投资趋势只有这个token才有数据 this.userdata.token
				this.$axios.get(ajaxUrl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log(ajaxUrl, res);
					if (res.data.success) {
						that.ajaxNum++;
						// console.log('列表数据', res.data)
						that.enterpristlist = res.data.list;
						that.provinceChartData = res.data.data.province;
						that.cityChartData = res.data.data.city;
						that.industryChartData=res.data.data.industry;
						that.industry2ChartData = res.data.data.industry2;
						// if(that.ajaxNum==1){ //要固定省份数据 24.4.1修改为所有省份数据展示
						// 	that.provinceOptionData = res.data.data.province;
						// }
						if(res.data.data.month.length>1){
								that.rankFun('fixedEchartBar', res.data.data.month);
						} 
						// that.rankFun('fixedEchartBar',res.data.data.city);
						var pietype = 1;
						if(that.provinceValue == 2){
								if(that.cityId === ''){
									pietype = 2;
								}else if(that.chooseNotion == 0){
									pietype = 3
								}
								else if(that.chooseNotion2 == ''){
									pietype = 4
								}
						}else{
							if(that.provinceId === ''){
								pietype = 1;
							}else if(that.cityId === ''){
								pietype = 2;
							}else if(that.chooseNotion == 0){
								pietype = 3
							}
							else if(that.chooseNotion2 == ''){
								pietype = 4
							}
						}
					that.PiechartFun('fixedEchartPie',pietype);
						that.totalPage = res.data.totalPage;
						that.pageSize = res.data.pageSize;
						that.total = res.data.totalRecord; 
					} else {
						that.$message({type:'warning',message:res.data.msg}); 
					}
					that.bus.$emit('loading', false);
					that.showechart=res.data.success;
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//弹出图表 概念企业数量排名
			rankFun(el, data) {
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var chart = echarts.init(document.getElementById(el));
				var that = this,
					xline = [],
					seriesline = [];
				var datalen = data.length - 1;
				for (var i = 0; i < data.length; i++) {
					xline.push(data[i].name);
					seriesline.push(data[i].num);
				};
				// console.log(data, xline, seriesline)
				var option = {
					tooltip: {
						formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c}"
					},
					xAxis: {
						type: 'category',
						data: xline
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: seriesline,
						type: 'line',
						smooth: true
					}]
				};
				chart.setOption(option);
				var startCharts = null;
			},
			PiechartFun(el,type,data) {
				console.log('饼图数据',el,type,data);
				this.cityInvestType=type;
				if(type == 1){
					data=this.provinceChartData;
				}else if(type == 2){
					data=this.cityChartData;
				}else if(type == 3){
					data=this.industryChartData;
				}else if(type == 4){
					data = this.industry2ChartData;
				}
	 
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var regionalchart = echarts.init(document.getElementById(el));
				let newdata=[],otherNum=0;
				for (var i = 0; i < data.length; i++) {
					if(i<10){
						newdata.push({name:data[i].name,value:data[i].num});
					}else{
						otherNum=otherNum+data[i].num;
					} 
				}
				newdata.push({name:'其他',value:otherNum})
				var that = this;
				var option = {
					title: {
						text: ' ',
					},
					tooltip: {
						trigger: 'item'
					},
					// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
					// },
					series: [{
						name: '',
						type: 'pie',
						radius: '60%',
						// center: ["52%", "50%"],
						data: newdata,
						label: {
							show: true,
							color: '#333',
							fontSize: 12,
							position: 'outside',
							formatter: '{b} : {d}%',
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				regionalchart.setOption(option);
			},


		}
	}
</script>

<style lang="scss">
	.orderField {
		display: block;
		width: 100%;
		height: 100%;

	}
</style>